import React from "react";
import moment from "moment/moment";

export class Timer extends React.Component {

    render() {
        let timerStyle = {
            background: this.getColorFor(this.props.time),
            width: "100px",
            height: "25px",
            textAlign: "center",
            verticalAlign: "middle",
            lineHeight: "25px",
            fontWeight: "bold",
            borderRadius: "3px",
            boxShadow: "0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"
        };
        let elapsed = moment.duration(this.props.time).format("h[:]m[:]s[:]");

        return(
            <div style={timerStyle}>
                {elapsed}
            </div>


        );
    }

    getColorFor(time) {
        let green = 8 * 60 * 1000;
        let yellow =  15 * 60 * 1000;
        let orange = 25 * 60 * 1000;
        if(time < green) {
            return "#58cf5c";
        } else if (time < yellow) {
            return "#fbee6b";
        } else if (time < orange) {
            return "#ec8738";
        } else {
            return "#fa2f2f";
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/TableList/timer.js